import { render } from "./EmailSidebar.vue?vue&type=template&id=238597bd&scoped=true"
import script from "./EmailSidebar.vue?vue&type=script&lang=js"
export * from "./EmailSidebar.vue?vue&type=script&lang=js"

import "./EmailSidebar.vue?vue&type=style&index=0&id=238597bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238597bd"]])

export default __exports__